import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FlaggedGlyph = /*#__PURE__*/createElement("g", {
  id: "flagged"
}, /*#__PURE__*/createElement("path", {
  d: "M29.5,67.5c-0.8,0-1.5-0.7-1.5-1.5V18c0-0.8,0.7-1.5,1.5-1.5S31,17.2,31,18v48C31,66.8,30.3,67.5,29.5,67.5z"
}), /*#__PURE__*/createElement("polygon", {
  points: "65.3,29.5 34,18 34,41"
}));
const Flagged = createSvg({
  name: 'flagged',
  path: /*#__PURE__*/createElement("g", {
    id: "flagged"
  }, /*#__PURE__*/createElement("path", {
    d: "M29.5,67.5c-0.8,0-1.5-0.7-1.5-1.5V18c0-0.8,0.7-1.5,1.5-1.5S31,17.2,31,18v48C31,66.8,30.3,67.5,29.5,67.5z"
  }), /*#__PURE__*/createElement("polygon", {
    points: "65.3,29.5 34,18 34,41"
  }))
});

export default Flagged;
export { FlaggedGlyph };
